<template>
    <div>
      <h2 class="mb-4">Editar Sala de Cultivo</h2>
      <form @submit.prevent="submitForm" class="mb-4">
        <div v-if="club_id !== null" class="mb-3">
          <label for="nombreClub" class="form-label">Club:</label>
          <input v-model="club.nombre" type="text" class="form-control" id="nombreClub" disabled />
        </div>
        <div class="mb-3">
          <label for="tipo" class="form-label">Tipo:</label>
          <select v-model="salaLocal.tipo" class="form-select" id="tipo" required>
            <option v-for="tipo in tiposSalas" :key="tipo" :value="tipo">{{ tipo }}</option>
          </select>
        </div>

        <div class="mb-3">
          <label for="nombre" class="form-label">Nombre:</label>
          <input v-model="salaLocal.nombre" type="text" class="form-control" id="nombre" required />
        </div>
  
        <div class="mb-3">
          <label for="descripcion" class="form-label">Descripción:</label>
          <textarea v-model="salaLocal.descripcion" class="form-control" id="descripcion"></textarea>
        </div>
  
        <button type="submit" class="btn btn-primary">Guardar Cambios</button>
      </form>
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  
  export default {
    props: {
      club_id: {
        type: Number,
        required: true,
      },
      sala: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        club: {},
        salaLocal: { ...this.sala }, // Crear una copia local de la prop `sala`
        tiposSalas: [],
      };
    },
    async created() {
      try {
        const clubResponse = await axios.get(`/api/clubes/${this.club_id}`);
        this.club = clubResponse.data;
        const tiposSalasResponse = await axios.get('/api/constantes/tipos_salas');
        this.tiposSalas = tiposSalasResponse.data;
      } catch (error) {
        console.error('Error al cargar los datos del club:', error);
      }
    },
    methods: {
      async submitForm() {
        try {
          await axios.put(`/api/salasDeCultivo/${this.salaLocal.id}`, this.salaLocal);
          alert('Sala de cultivo actualizada con éxito');
          this.$emit('accionTerminada'); // Informar al padre que la acción se completó
        } catch (error) {
          console.error('Error al actualizar la sala de cultivo:', error);
        }
      },
    },
  };
  </script>
  
  <style scoped>
  /* Estilos específicos para este componente si es necesario */
  </style>
  